import { useState } from "react";
import { formatDateRu } from "../../../utils/appointmentLabels";
import {
  buildCompetitionMedalDescription,
  getPlacementMedal,
  getPlacementLabel,
} from "../../../utils/competitionResultUtils";
import s from "./clientApp.module.css";

export default function ClientCompetitionMedals({
  medals = [],
  title = "Медали",
  emptyHint = "Медали появятся, если вы займёте призовое место (1–3).",
}) {
  const [activeId, setActiveId] = useState(null);
  const active = medals.find((m) => m.id === activeId) || null;

  if (!medals.length) {
    return (
      <section className={s.memberMedalsSection} aria-label={title}>
        <h2 className={s.memberMedalsTitle}>{title}</h2>
        <p className={s.memberMedalsEmpty}>{emptyHint}</p>
      </section>
    );
  }

  return (
    <section className={s.memberMedalsSection} aria-label={title}>
      <h2 className={s.memberMedalsTitle}>
        {title} <span className={s.memberMedalsCount}>{medals.length}</span>
      </h2>
      <div className={s.memberMedalsRow}>
        {medals.map((medal) => {
          const icon = medal.medal || getPlacementMedal(medal.placement);
          const isOn = activeId === medal.id;
          return (
            <button
              key={medal.id}
              type="button"
              className={`${s.memberMedalBtn} ${isOn ? s.memberMedalBtnOn : ""}`}
              title={medal.description || buildCompetitionMedalDescription(medal)}
              aria-pressed={isOn}
              onClick={() => setActiveId(isOn ? null : medal.id)}
            >
              <span className={s.memberMedalIcon} aria-hidden>
                {icon}
              </span>
            </button>
          );
        })}
      </div>
      {active ? (
        <div className={s.memberMedalDetail} role="status">
          <p className={s.memberMedalDetailLead}>
            <span className={s.memberMedalDetailIcon} aria-hidden>
              {active.medal || getPlacementMedal(active.placement)}
            </span>
            <strong>{getPlacementLabel(active.placement)}</strong>
          </p>
          <p className={s.memberMedalDetailText}>
            {active.description || buildCompetitionMedalDescription(active)}
          </p>
          {active.competition?.start_datetime ? (
            <p className={s.memberMedalDetailMeta}>
              {formatDateRu(active.competition.start_datetime, {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
              {active.competition.venue_name
                ? ` · ${active.competition.venue_name}`
                : ""}
            </p>
          ) : null}
        </div>
      ) : (
        <p className={s.memberMedalsHint}>Нажмите на медаль, чтобы увидеть за что она</p>
      )}
    </section>
  );
}
